// Browser-safe conversion shared by page saves and navigation-only heading saves.
module.exports = function navigationProperties(root) {
    const properties = {};
    if (root.type === 'navHeading_TabNavHeading') properties.isTabContainer = true;
    if (root.type === 'page_NavigationLink') properties.isNavigationLink = true;
    if (root.type === 'page_NavigationSelectedContextPage') properties.isMenuList = true;

    let modifier = root.inputs?.securityModifier?.block;
    while (modifier) {
        if (modifier.fields) {
            const property = modifier.type.replace(/^accessModifier_(.)/, (_, first) => first.toLowerCase());
            (properties[property] ||= []).push(structuredClone(modifier.fields));
        }
        modifier = modifier.inputs?.securityModifier?.block;
    }
    return Object.assign(properties, root.fields);
};
